import { useTranslation } from "react-i18next";

import "./styles.scss";

interface TextTabsProps {
  activeTextTab: string;
  onChange: (tabId: string) => void;
}

function TextTabs({ activeTextTab, onChange }: TextTabsProps) {
  const { t } = useTranslation();

  const tabs: { id: string; label: string }[] = [
    {
      id: "organization",
      label: t("frontend.test.category.organization", "Organization"),
    },
    { id: "team", label: t("frontend.test.category.team", "Team") },
    {
      id: "leadership",
      label: t("frontend.test.category.leadership", "Leadership"),
    },
  ];

  return (
    <div className="text-tabs">
      {tabs.map(({ id, label }) => (
        <button
          key={id}
          onClick={() => onChange(id)}
          className={`tab-item ${activeTextTab === id ? "active" : ""}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default TextTabs;
